const countryCodeParser = isDev => (req, res, next) => {
  const country = isDev
    ? process.env.COUNTRY_CODE || "US"
    : req.get("X-Country-Code");
  req.country = country;
  next();
};

function toKm(miles) {
  if (!miles || isNaN(miles)) {
    return 0;
  }
  return miles * 1.60934;
}

export { countryCodeParser as c, toKm as t };
